import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from '@gatsbyjs/reach-router';

import { ModalEnum } from '../../ModalEnum';
import { useRouteContext } from '../../RouteProvider';
import type { ReduxState } from '../../store';
import { closeModal } from '../../store/app';

import ForgottenPasswordModal from './ForgottenPasswordModal';
import { MissingDrivingLicenseNumberModal } from './MissingDrivingLicenseNumberModal';
import RegionSelectDialog from './RegionSelectDialog';
import SignInModal from './SignInModal';
import SignUpModal from './SignUpModal';
import TripModal from './TripModal';

export default function Modals() {
  const dispatch = useDispatch();
  const { openedModal, options } = useSelector((state: ReduxState) => ({
    openedModal: state.app.modal,
    options: state.app.modalOptions,
  }));
  const location = useLocation();
  const { navigate } = useRouteContext();

  const handleCloseModal = useCallback(
    (success = true) => {
      const path = options?.redirect;
      dispatch(closeModal(success));
      if (success && path) {
        navigate(path, { replace: true });
        return;
      }
    },
    [dispatch, navigate, location, options],
  );

  switch (openedModal) {
    case ModalEnum.TRIP:
      return <TripModal closeModal={handleCloseModal} />;
    case ModalEnum.SIGN_IN:
      return <SignInModal onClose={handleCloseModal} />;
    case ModalEnum.SIGN_UP:
      return <SignUpModal onClose={handleCloseModal} />;
    case ModalEnum.PASSWORD_RESET:
      return <ForgottenPasswordModal onClose={handleCloseModal} />;
    case ModalEnum.REGION_SELECT:
      return <RegionSelectDialog />;
    case ModalEnum.DRIVING_LICENCE_NUMBER:
      return <MissingDrivingLicenseNumberModal closeModal={handleCloseModal} />;
  }

  return null;
}
